export default __webpack_public_path__ + "static/media/check-circle.d683e4a5.svg";